import aggregate from './aggregate'
import colors from './colors'
import customer from './customer'
import courseMenu from './courseMenu'
import courseRanking from './courseRanking'
import route from './route'
import call from './call'
import tag from './tag'
import cancel from './cancel'
import progress from './progress'
import unit from './unit'
import target from './target'
import csv from './csv'

export default {
  namespaced: true,
  state: {
    busy: false,
    menuOpen: true,
  },
  modules: {
    aggregate,
    colors,
    customer,
    courseMenu,
    courseRanking,
    route,
    call,
    tag,
    cancel,
    progress,
    unit,
    target,
    csv,
  },
  mutations: {
    busy(state, busy) {
      state.busy = busy
    },
    menu(state, menu) {
      state.menuOpen = menu
    },
  },
  getters: {},
  actions: {},
}
